import TotalCard from '../TotalCard/TotalCard';
import { TotalEmployeeDetailsWrapper } from './TotalEmployeeDetails.styled';
import SchoolIcon from '@mui/icons-material/School';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import useTranslation from 'Hooks/useTranslation';
import type { EmployeeCoursesReportTotalsI } from 'types';
import { buildTime } from 'Pages/reports/utils/buildTime';

interface Props {
  totals: EmployeeCoursesReportTotalsI;
}

const TotalEmployeeDetails = ({ totals }: Props) => {
  const { t2 } = useTranslation('employees_courses_report');
  const trainingHours = buildTime(totals?.totalTrainingHours, t2);

  return (
    <TotalEmployeeDetailsWrapper>
      <TotalCard
        value={totals.totalCourses}
        label={t2('total_courses')}
        icon={<SchoolIcon />}
        description={t2('total_courses_description')}
      />
      <TotalCard
        value={totals.completedCourses}
        label={t2('completed_courses')}
        icon={<TrendingUpIcon />}
        description={t2('completed_courses_description')}
      />
      <TotalCard
        value={totals.pendingCourses}
        label={t2('pending_courses')}
        icon={<PendingActionsIcon />}
        description={t2('pending_courses_description')}
      />
      <TotalCard
        value={totals.approvedEvaluations}
        label={t2('passed_evaluations')}
        icon={<AssignmentTurnedInIcon />}
        description={t2('passed_evaluations_description')}
      />
      <TotalCard
        value={trainingHours}
        label={t2('total_training_hours')}
        icon={<QueryBuilderIcon />}
        description={t2('total_training_hours_description')}
      />
    </TotalEmployeeDetailsWrapper>
  );
};

export default TotalEmployeeDetails;
